import React from 'react';

const TaskIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66615 3.16699H4.79948C4.05274 3.16699 3.6791 3.16699 3.39388 3.31232C3.143 3.44015 2.93917 3.64397 2.81134 3.89486C2.66602 4.18007 2.66602 4.55372 2.66602 5.30046V11.7005C2.66602 12.4472 2.66602 12.8204 2.81134 13.1056C2.93917 13.3565 3.143 13.5606 3.39388 13.6885C3.67882 13.8337 4.05201 13.8337 4.79729 13.8337H11.2014C11.9467 13.8337 12.3193 13.8337 12.6043 13.6885C12.8552 13.5606 13.0597 13.3563 13.1875 13.1054C13.3327 12.8205 13.3327 12.4477 13.3327 11.7024V9.83366M6 7.50037L8 9.50037L13 4.50037"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaskIcon;
